'use client';
import { createContext } from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

const PriceBarQuantityContext = createContext(void 0);
PriceBarQuantityContext.displayName = 'PriceBarQuantityContext';
const usePriceBarQuantityContext = ()=>useNonNullishContext(PriceBarQuantityContext);

export { PriceBarQuantityContext, usePriceBarQuantityContext };
